import { isAfter } from 'date-fns';
import { User } from 'shared/types/user';

export const getUserLastSubscription = (user: User | null | undefined) =>
  user?.subscriptions?.reduce((acc, subscription) => {
    // lifetime is definitely the last subscription
    if (!subscription.expiresAt) {
      return subscription;
    }

    // no acc (weird, should not be possible)
    if (!acc) {
      return subscription;
    }

    // previous lifetime
    if (!acc.expiresAt) {
      return acc;
    }

    // check to see if the subscription expires after acc, if so, it is the later subscription
    if (isAfter(subscription.expiresAt, acc.expiresAt)) {
      return subscription;
    }

    return acc;
  }, user?.subscriptions[0]);
